export default "__VITE_ASSET__JPeKz_W1__"